import React, { useContext, useEffect, useState } from "react";
import { Grid, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { sumTimes } from "../../../../utils/time";
import { LocaleContext } from "../../../../routing/LangRouter";
import TicketArrow from "../../../common/ticket-arrow/ticket-arrow";

//import images and icons
import { Airplane } from "iconsax-react";
import AirplaneSvg from "../../../../assets/icons/airplane.svg";

function IntFlightItemDetails({ flightItem, details, title }) {
    //general variables
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);

    //sessionStorage variables
    const intFlightInformation = JSON.parse(sessionStorage.getItem("intFlightInformation"));

    //calculate the flight duration
    const [totalDurationTime, setTotalDurationTime] = useState();
    useEffect(() => {
        if (!!details) {
            let timesArray = [];
            details?.forEach(segment => {
                timesArray.push(segment?.connection_time, segment?.flight_duration);
                return timesArray;
            });
            setTotalDurationTime(sumTimes(timesArray));
        }
    }, [details]);

    return (
        <Grid container item xs={12} rowGap={2}>
            <Grid container item xs={12} rowGap={1} columnGap={{ xs: 0.5, md: 1 }} alignItems="center">
                {!!intFlightInformation?.returnDate && (
                    <Grid className="flight-item__title" container item xs="auto">
                        <span>{title}</span>
                    </Grid>
                )}
                {flightItem?.cabin?.persian && (
                    <Grid className="flight-item__label" container item xs="auto">
                        <span>{locale === "en" ? flightItem?.cabin?.english : flightItem?.cabin?.persian}</span>
                    </Grid>
                )}
                {flightItem?.persian_type && (
                    <Grid className="flight-item__label" container item xs="auto">
                        <span>{locale === "en" ? flightItem?.type : flightItem?.persian_type}</span>
                    </Grid>
                )}

                {flightItem.fares.type === 4 && (
                    <Grid className="flight-item__label" container item xs="auto">
                        <span>{t("Flight.Instant Booking")}</span>
                    </Grid>
                )}
            </Grid>

            <Grid container item xs={12} justifyContent="space-between" alignItems={{ xs: "center", md: "flex-start" }}>
                <Grid container item xs={3.5} md={4} rowGap={1} columnGap={1} direction="column" alignItems="flex-start">
                    <Grid container item xs="auto" columnGap={1} justifyContent={{ xs: "center", md: "flex-start" }}>
                        {details?.map((segment, index) => {
                            return (
                                <img className="flight-item__int-airline-logo" key={index} src={segment?.airline?.image} alt={flightItem?.airline} />
                            );
                        })}
                    </Grid>
                    <Grid container item xs={12} md="auto" rowGap={1} justifyContent="center">
                        <span className="flight-item__airline-name">
                            {details?.length > 1
                                ? t("multipleAirlines")
                                : locale === "en"
                                  ? details?.[0]?.airline?.english
                                  : details?.[0]?.airline?.persian}
                        </span>
                    </Grid>
                </Grid>

                <Grid container item xs={8.5} md={8} rowGap={4}>
                    <Grid container item xs={12} justifyContent="space-around" alignItems="center">
                        <Grid container item xs="auto" direction="column" justifyContent="cenetr" alignItems="center">
                            <Grid className="flight-item__city-name" component="span" container item xs="auto" display={{ xs: "none", md: "flex" }}>
                                {details?.[0]?.departure?.city?.persian} ({details?.[0]?.departure?.terminal?.code})
                            </Grid>
                            <span className="flight-item__time">{details?.[0]?.departure_time?.split(":", 2).join(":")}</span>
                        </Grid>

                        <TicketArrow list={details} icon={<img src={AirplaneSvg} />} />

                        <Grid container item xs="auto" direction="column" justifyContent="cenetr" alignItems="center">
                            <Grid className="flight-item__city-name" component="span" container item xs="auto" display={{ xs: "none", md: "flex" }}>
                                {details?.[details.length - 1]?.destination?.city?.persian} (
                                {details?.[details.length - 1]?.destination?.terminal?.code})
                            </Grid>
                            <span className="flight-item__time">{details?.[details.length - 1]?.destination_time?.split(":", 2).join(":")}</span>
                        </Grid>
                    </Grid>

                    <Grid
                        className="flight-item__total-duration-time"
                        container
                        item
                        xs={12}
                        justifyContent="center"
                        alignItems="center"
                        display={{ xs: "none", md: "flex" }}
                    >
                        <span>
                            {totalDurationTime?.split(":")[0]} {t("hours")}
                            {parseInt(totalDurationTime?.split(":")[1]) !== 0 ? ` و ${totalDurationTime?.split(":")[1]} ${t("minutes")}` : ""}
                        </span>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default IntFlightItemDetails;
